import {
	booleanAttribute,
	Component,
	forwardRef,
	Input,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { byId, getIds } from "@app/helpers"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { UploadPredictionFileComponent } from "@app/upload-prediction-file/upload-prediction-file.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-gen-upload-prediction-btn",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ModalWrapComponent,
		forwardRef(() => UploadPredictionFileComponent),
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (isV2) {
			<button
				class="btn btn-primary"
				(click)="isOpen = true"
			>
				{{ "scan_expense" | langVal }}
			</button>
		} @else {
			<button
				class="btn btn-primary"
				(click)="isOpen = true"
				style="margin-inline: 10px"
			>
				{{ "scan_expense" | langVal }}
			</button>
		}

		@if (isOpen) {
			<app-modal-wrap
				(onClose)="isOpen = false"
				modalWrapperClass="modal-800"
				title="scan_expense"
			>
				<app-upload-prediction-file (onClose)="isOpen = false" />
			</app-modal-wrap>
		}
	`,
})
export class GenTableUploadPredictionBtnComponent {
	@Input({ transform: booleanAttribute }) isV2: boolean = false
	isOpen: boolean = false
}
